import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import SummarizeIcon from '@mui/icons-material/Summarize';
const GeneratePPTButton = ({ onClick, label = "Generate Report", disabled = false }) => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t(label)}>
      <span>
        <IconButton onClick={onClick} variant="Light Green" disabled={disabled}>
          <SummarizeIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};
export default GeneratePPTButton;
